// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root___LZeh","noInteraction":"EventWrapper_noInteraction__3s1Uz","pointerPassthrough":"EventWrapper_pointerPassthrough__3LtTi"};